var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 14.75V16.25C4.75 17.9069 6.09315 19.25 7.75 19.25H16.25C17.9069 19.25 19.25 17.9069 19.25 16.25V14.75",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 4.75C12.75 4.33579 12.4142 4 12 4C11.5858 4 11.25 4.33579 11.25 4.75V12.3401L9.2996 10.2397C9.01775 9.93613 8.5432 9.91855 8.23966 10.2004C7.93613 10.4823 7.91856 10.9568 8.20041 11.2603L11.4488 14.7586C11.4531 14.7633 11.4575 14.7679 11.4619 14.7725C11.4694 14.7802 11.4771 14.7877 11.4849 14.7951C11.6193 14.9221 11.8005 15 12 15C12.2094 15 12.3988 14.9142 12.5348 14.7758C12.5404 14.7701 12.5459 14.7644 12.5513 14.7585L15.7996 11.2603C16.0815 10.9568 16.0639 10.4823 15.7603 10.2004C15.4568 9.91855 14.9823 9.93613 14.7004 10.2397L12.75 12.3401V4.75Z",
    fill: "#676879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.05fb1030e5aa9308c42ad2f87b6f267e.svg";
export { ForwardRef as ReactComponent };